import { render, staticRenderFns } from "./bm-file.vue?vue&type=template&id=27736b09&scoped=true&"
import script from "./bm-file.vue?vue&type=script&lang=js&"
export * from "./bm-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27736b09",
  null
  
)

export default component.exports